import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { Editor, Events, stateMap, mouseType,
// judgeState
 } from '../config/editor';
import { transformVertex } from '@blade/common/utils/rzcanvas/util';
let ImageEditor = class ImageEditor extends Vue {
    drawState;
    showDrawer;
    imageSrc;
    options;
    config;
    outerCircles;
    editorMode;
    currVal;
    containerStyle = {};
    Editor; // it will not be observe
    mouseState = '';
    scale = 1;
    // 缩放配置
    maxScale = 5;
    minScale = 1;
    canvasPosition = {
        x: 0,
        y: 0,
    };
    canvasStyle = {};
    currentPosition = {
        clientX: 0,
        clientY: 0,
    };
    prevPosition = {
        clientX: 0,
        clientY: 0,
    };
    hoverIndex = -1;
    mouseHoverVertex = { x: 0, y: 0 };
    divStyle = {};
    imageOriginSize = { width: 0, height: 0 };
    isRightClicking = false;
    showEdit = false;
    editStyle = {};
    showAdd = false;
    addStyle = {};
    currCircleIndex = -1;
    imageLoading = false;
    prevScale = 0;
    get showCanvas() {
        return this.showDrawer || this.drawState;
    }
    handleImageChange() {
        this.destroyEditor();
        this.init();
    }
    onShowEditChange(newVal) {
        this.hoverIndex = -1;
    }
    onCirclesChange(newVal) {
        console.log('new val:', newVal);
        if (this.Editor) {
            // this.Editor.circles = newVal;
            this.Editor.addCircles(newVal);
            this.Editor.drawCircles();
        }
    }
    onCurrValChange(newVal) {
        this.handleResize();
    }
    handleDrawCircles(circles) {
        return circles;
    }
    handleDrawCircleDone(circles) {
        console.log('circles');
        return circles;
    }
    handleDelete(e) {
        console.log('delete');
        const currCircle = this.Editor.circles[this.currCircleIndex];
        this.$emit('on-delete', currCircle);
    }
    handleEdit() {
        const currCircle = this.Editor.circles[this.currCircleIndex];
        this.$emit('on-edit', currCircle);
    }
    handleCreate() {
        this.$emit('on-create');
    }
    resetStyle() {
        this.canvasPosition = { x: 0, y: 0 };
        this.currentPosition = { clientX: 0, clientY: 0 };
        this.scale = 1;
        this.canvasStyle = this.getCanvasStyle();
    }
    mounted() {
        this.init();
        this.addDocumentListen();
    }
    beforeDestroy() {
        const parentRef = this.$refs.parent;
        if (!parentRef) {
            return;
        }
        parentRef.removeEventListener('mouseup', this.handleMouseUp);
        parentRef.removeEventListener('mousemove', this.handleMouseUp);
        parentRef.removeEventListener('contextmenu', this.handleMouseUp);
        this.destroyEditor();
    }
    addDocumentListen() {
        const parentRef = this.$refs.parent;
        if (!parentRef) {
            return;
        }
        parentRef.removeEventListener('mouseup', this.handleMouseUp);
        parentRef.addEventListener('mouseup', this.handleMouseUp);
        parentRef.addEventListener('mousemove', this.handleCanvasMouseMove);
        parentRef.addEventListener('contextmenu', this.handleClick);
    }
    handleClick(event) {
        event.preventDefault();
    }
    getImageDom() {
        if (!this.imageSrc) {
            throw new Error('the imageSrc must exist and be unique ');
        }
        const image = new Image();
        return new Promise((resolve, reject) => {
            image.src = this.imageSrc;
            image.onload = event => {
                const target = event.target;
                this.imageOriginSize = {
                    width: target?.width || 0,
                    height: target?.height || 0,
                };
                const { naturalWidth: width, naturalHeight: height } = target;
                const containerStyle = this.$el.getBoundingClientRect();
                this.containerStyle = containerStyle;
                console.log('container style:', this.containerStyle);
                resolve({
                    containerStyle: containerStyle,
                    imageSize: { width, height },
                    image: event.target,
                });
            };
        });
    }
    async init() {
        this.imageLoading = true;
        const { containerStyle, imageSize, image } = await this.getImageDom();
        this.imageLoading = false;
        const { circleLength } = this.config;
        const config = { containerStyle, imageSize, circleLength };
        const canvasElem = this.$refs.canvas;
        const options = this.options;
        if (image && containerStyle.width && containerStyle.height) {
            this.Editor = new Editor(canvasElem, config, options, image);
            this.Editor.on(Events.drawCircles, this.handleDrawCircles);
            this.Editor.on(Events.drawCircleDone, this.handleDrawCircleDone);
            // this.Editor.circles = this.outerCircles;
            this.Editor.addCircles(this.outerCircles);
            console.log('outercircle:', this.outerCircles);
            this.Editor.drawCircles();
        }
    }
    handleMouseDown(event) {
        this.mouseState = mouseType.down;
        this.currentPosition = {
            clientX: event.clientX,
            clientY: event.clientY,
        };
        this.prevPosition = {
            clientX: event.clientX,
            clientY: event.clientY,
        };
    }
    handleCanvasMouseMove(event) {
        if (this.mouseState === mouseType.down) {
            this.mouseState = mouseType.move;
        }
        if (this.mouseState !== mouseType.move) {
            return;
        }
        this.moveCanvas(event);
    }
    handleMouseUp(event) {
        this.hoverIndex = -1;
        this.mouseState = mouseType.up;
        const vertex = transformVertex(event, this.scale);
        // console.log("vertext:", vertex)
        let circleIndex = -1;
        circleIndex = this.Editor ? this.Editor.isCircleExist(vertex) : -1;
        if (!event || !this.$el.contains(event.target)) {
            this.currentPosition = null;
            return;
        }
        switch (this.drawState) {
            case stateMap.circle:
                if (
                // 鼠标移动了则不画标注
                this.prevPosition.clientX !== this.currentPosition?.clientX ||
                    this.prevPosition.clientY !== this.currentPosition?.clientY) {
                    break;
                }
                if (this.Editor.circles.length && circleIndex >= 0) {
                    // this.Editor.removeCircle(circleIndex);
                    return;
                }
                else {
                    if (this.editorMode === 'EDIT') {
                        this.Editor.addCircle(vertex);
                    }
                }
                break;
            case stateMap.screenShot:
                // screenShot = this.Editor.getScreeShot();
                // if (!screenShot) {
                //   break;
                // }
                // this.handleScreenShotDone(screenShot);
                break;
            case stateMap.drawRects:
                // this.selectRect(vertex);
                break;
            default:
                break;
        }
        this.currentPosition = null;
    }
    handleWheel(event, scaleStep = 0.1) {
        // this.swallowEvent(event);
        // const maxScale = this.Editor && this.Editor.rect.scale ? this.Editor.rect.scale : 1;
        const canvasElem = this.$refs.canvas;
        // 当前位置
        const boundingRect = canvasElem.getBoundingClientRect();
        // if (boundingRect.width >= this.imageOriginSize.width && event.deltaY < 0) {
        // return;
        // }
        const scaleFlag = event.deltaY < 0;
        let newScale = this.scale + scaleStep * (scaleFlag ? 1 : -1);
        if (newScale > this.maxScale) {
            newScale = this.maxScale;
        }
        else if (newScale < this.minScale) {
            newScale = this.minScale;
        }
        const x = event.clientX - boundingRect.left;
        const y = event.clientY - boundingRect.top;
        const changeRate = newScale / this.scale;
        this.scale = newScale;
        if (newScale === this.minScale) {
            this.canvasPosition = {
                x: 0,
                y: 0,
            };
        }
        else {
            // 换算后新的位置
            this.canvasPosition = {
                x: this.canvasPosition.x - (changeRate - 1) * x,
                y: this.canvasPosition.y - (changeRate - 1) * y,
            };
        }
        this.canvasStyle = this.getCanvasStyle();
        this.Editor.zoom(this.scale);
    }
    handleResize() {
        const val = Number(this.currVal);
        const maxScale = this.Editor && this.Editor.rect.scale ? this.Editor.rect.scale : 1;
        const canvasElem = this.$refs.canvas;
        const newScale = 1 + Number(((maxScale - 1) * (val / 100)).toFixed(2));
        // this.scale = newScale;
        const x = canvasElem.width / 2;
        const y = canvasElem.height / 2;
        console.log('canvas elem:', canvasElem);
        const changeRate = newScale / this.scale;
        this.scale = newScale;
        console.log('canvas elem:', newScale);
        this.canvasPosition = {
            x: this.canvasPosition.x - (changeRate - 1) * x,
            y: this.canvasPosition.y - (changeRate - 1) * y,
        };
        this.calibrateCanvas(canvasElem);
        this.prevScale = val;
    }
    calibrateCanvas(canvasElem) {
        const divRect = this.$refs.parent;
        const divBoundingRect = divRect.getBoundingClientRect();
        if (this.canvasPosition.x > 0) {
            this.canvasPosition.x = 0;
        }
        if (this.canvasPosition.y > 0) {
            this.canvasPosition.y = 0;
        }
        if (this.canvasPosition.x + divBoundingRect.width * this.scale < divBoundingRect.width) {
            const diffRight = divBoundingRect.width - divBoundingRect.width * this.scale - this.canvasPosition.x;
            this.canvasPosition.x = this.canvasPosition.x + diffRight;
        }
        if (this.canvasPosition.y + divBoundingRect.height * this.scale < divBoundingRect.height) {
            const diffHeight = divBoundingRect.height - divBoundingRect.height * this.scale - this.canvasPosition.y;
            this.canvasPosition.y = this.canvasPosition.y + diffHeight;
        }
        this.canvasStyle = this.getCanvasStyle();
        this.Editor.zoom(this.scale);
    }
    moveCanvas(event) {
        this.swallowEvent(event);
        this.mouseState = mouseType.move;
        const { clientX, clientY } = event;
        const movementX = this.currentPosition ? clientX - this.currentPosition.clientX : clientX - 0;
        const movementY = this.currentPosition ? clientY - this.currentPosition?.clientY : clientY - 0;
        /* 距离太小不做操作 */
        if ((movementX > 0 && movementX < 5) ||
            (movementY > 0 && movementY < 5) ||
            (movementX < 0 && movementX > -5) ||
            (movementY < 0 && movementY > -5)) {
            return;
        }
        this.checkMove(movementX, movementY, this.currentPosition?.clientX || 0, this.currentPosition?.clientY || 0, event);
        // this.canvasPosition.x += movementX;
        // this.canvasPosition.y += movementY;
        // this.canvasStyle = this.getCanvasStyle();
        // this.currentPosition = { clientX, clientY };
    }
    checkMove(movementX, movementY, preX, preY, event) {
        const canvasEle = this.$refs.canvas;
        const boundingRect = canvasEle.getBoundingClientRect();
        const containerEle = this.$refs.parent;
        const divRect = containerEle.getBoundingClientRect();
        let clientCurrX = preX;
        let clientCurrY = preY;
        if (movementY < 0 && movementY + boundingRect.bottom >= divRect.bottom) {
            this.canvasPosition.y += movementY;
            clientCurrY = event.clientY;
        }
        if (movementY > 0 && boundingRect.top + movementY <= divRect.top) {
            this.canvasPosition.y += movementY;
            clientCurrY = event.clientY;
        }
        if (movementX < 0 && movementX + boundingRect.right >= divRect.right) {
            this.canvasPosition.x += movementX;
            clientCurrX = event.clientX;
        }
        if (movementX > 0 && boundingRect.left + movementX <= divRect.left) {
            this.canvasPosition.x += movementX;
            clientCurrX = event.clientX;
        }
        this.canvasStyle = this.getCanvasStyle();
        this.currentPosition = { clientX: clientCurrX, clientY: clientCurrY };
    }
    // 设置canvas的位置
    getCanvasStyle() {
        const { width, height } = this.containerStyle;
        return {
            width: `${width * this.scale}px`,
            height: `${height * this.scale}px`,
            top: `${this.canvasPosition.y}px`,
            left: `${this.canvasPosition.x}px`,
            'border-radius': '5px',
        };
    }
    swallowEvent(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    destroyEditor() {
        this.Editor && this.Editor.dispose();
        this.Editor = null;
    }
};
__decorate([
    Prop({ type: Number, default: 0, required: true })
], ImageEditor.prototype, "drawState", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ImageEditor.prototype, "showDrawer", void 0);
__decorate([
    Prop({ type: String, default: '', required: true })
], ImageEditor.prototype, "imageSrc", void 0);
__decorate([
    Prop({
        type: Object,
        default() {
            return {};
        },
    })
], ImageEditor.prototype, "options", void 0);
__decorate([
    Prop({
        type: Object,
        default() {
            return {};
        },
    })
], ImageEditor.prototype, "config", void 0);
__decorate([
    Prop({ type: Array, default: false })
], ImageEditor.prototype, "outerCircles", void 0);
__decorate([
    Prop({ type: String, default: 'VIEW' })
], ImageEditor.prototype, "editorMode", void 0);
__decorate([
    Prop({ type: String, default: '0' })
], ImageEditor.prototype, "currVal", void 0);
__decorate([
    Watch('imageSrc')
], ImageEditor.prototype, "handleImageChange", null);
__decorate([
    Watch('showEdit')
], ImageEditor.prototype, "onShowEditChange", null);
__decorate([
    Watch('outerCircles', { immediate: true, deep: true })
], ImageEditor.prototype, "onCirclesChange", null);
__decorate([
    Watch('currVal')
], ImageEditor.prototype, "onCurrValChange", null);
__decorate([
    Emit('draw-circles')
], ImageEditor.prototype, "handleDrawCircles", null);
__decorate([
    Emit('draw-circle-done')
], ImageEditor.prototype, "handleDrawCircleDone", null);
ImageEditor = __decorate([
    Component({
        name: 'DeviceEditor',
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], ImageEditor);
export default ImageEditor;
